import { render, staticRenderFns } from "./ClientInsightModal.vue?vue&type=template&id=3d5fca0b&scoped=true&"
import script from "./ClientInsightModal.vue?vue&type=script&lang=js&"
export * from "./ClientInsightModal.vue?vue&type=script&lang=js&"
import style0 from "./ClientInsightModal.vue?vue&type=style&index=0&id=3d5fca0b&prod&lang=scss&"
import style1 from "./ClientInsightModal.vue?vue&type=style&index=1&id=3d5fca0b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5fca0b",
  null
  
)

export default component.exports